import { render, staticRenderFns } from "./UserEditTabWasl.vue?vue&type=template&id=c8330330"
import script from "./UserEditTabWasl.vue?vue&type=script&lang=js"
export * from "./UserEditTabWasl.vue?vue&type=script&lang=js"
import style0 from "./UserEditTabWasl.vue?vue&type=style&index=0&id=c8330330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports